<div class="sdg-ph-sale-editor" data-saleID="{{Sale.SaleID}}">
    <div class="rps1-div-book-page-row">

    </div>

    <div class="row">
        <div class="col-sm-12 form-group">
            <button class="btn btn-default rps1-btn-add-deed">Add Book/Page</button>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-6 form-group">
            <label class="form-label">Sale Price</label>
            <input type="text" class="form-control rps1-ph-sale-price" name="{{Namespace}}-rps1-ph-sale-price" value="{{Sale.Price}}" />
        </div>
        <div class="col-sm-6 form-group">
            <label class="form-label">Lot Size</label>
            <input type="text" class="form-control rps1-ph-sale-lotsize" name="{{Namespace}}-rps1-ph-sale-lotsize" value="{{Sale.LotSize}}" />
        </div>
    </div>

    <div class="row">
        <div class="col-sm-12 form-group">
            <label class="form-label">Transfer Conditions</label>
            <input type="text" class="form-control rps1-ph-sale-trscon" name="{{Namespace}}-rps1-ph-sale-trscon" value="{{Sale.TransferConditions}}" />
        </div>
    </div>

    <div class="row">
        <div class="col-sm-12 form-group">
            <label class="form-label">Notes</label>
            <input type="text" class="form-control rps1-ph-sale-notes" name="{{Namespace}}-rps1-ph-sale-notes" value="{{Sale.Notes}}" />
        </div>
    </div>

    <div class="row">
        <div class="col-sm-4 form-group">
            <label class="form-label">Record Status</label>
            <fieldset>
                {{#each Cards}}
                    <label>
                        {{Name}}
                        <input type="radio" name="{{@root.Namespace}}-rps1-ph-sale-recordstatus" {{#if IsSelected}}checked{{/if}} value="{{ID}}" />
                    </label>
                {{/each}}
            </fieldset>
        </div>
    </div>
</div>